export default __webpack_public_path__ + "static/media/FastAPI.a8d6e24e.svg";